// extracted by mini-css-extract-plugin
module.exports = {"columnLeft":"styles_columnLeft__24n1q","titleH2":"styles_titleH2__3jWEg"};